class ProductRecommendationsSlider extends HTMLElement {
  swiper = null;

  #intersectionObserver = new IntersectionObserver(
    (entries, observer) => {
      if (!entries[0]?.isIntersecting) return;
      observer.disconnect();
      this.#loadRecommendations();
    },
    { rootMargin: '0px 0px 400px 0px' }
  );

  connectedCallback() {
    this.#intersectionObserver.observe(this);
  }

  disconnectedCallback() {
    this.#intersectionObserver.disconnect();
    this.swiper?.destroy(true, true);
  }

  // 1. On va d'abord chercher les recommandations (Section Rendering API)...
  async #loadRecommendations() {
    const { productId, sectionId, intent, recommendationsPerformed } = this.dataset;
    const id = this.id;

    if (recommendationsPerformed === 'true') {
      // Rendu déjà effectué côté serveur (ex : preview de l'éditeur de thème)
      this.#initSwiper();
      return;
    }

    if (!productId || !id) {
      this.remove();
      return;
    }

    const url = `${this.dataset.url}&product_id=${productId}&section_id=${sectionId}&intent=${intent}`;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Server returned ${response.status}`);

      const text = await response.text();
      const doc = document.createElement('div');
      doc.innerHTML = text;
      const recommendations = doc.querySelector(`product-recommendations-slider[id="${id}"]`);

      if (!recommendations?.innerHTML || !recommendations.innerHTML.trim().length) {
        throw new Error('No recommendations available');
      }

      this.dataset.recommendationsPerformed = 'true';
      this.innerHTML = recommendations.innerHTML;

      // 2. ...puis on crée le slider en JS une fois les produits injectés dans le DOM.
      this.#initSwiper();
    } catch (error) {
      if (!window.Shopify?.designMode) {
        console.error('Erreur lors du chargement des recommandations produits :', error);
      }
      this.remove();
    }
  }

  #initSwiper() {
    const swiperEl = this.querySelector('.bloc-slider-produits-swiper.swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    this.swiper = new Swiper(swiperEl, {
      direction: 'horizontal',
      slidesPerView: 3,
      slidesPerGroup: 1,
      spaceBetween: 32,
      loop: true,
      effect: 'slide' /* || 'fade' || 'cube' || 'coverflow' || 'flip' || 'creative' || 'cards' */,
      speed: 300,
      breakpoints: {
        1024: {
          slidesPerView: 4,
          spaceBetween: 112,
        },
      },
      pagination: {
        el: this.querySelector('.custom-swiper-pagination'),
        type: 'bullets',
      },
      navigation: {
        nextEl: this.querySelector('.custom-swiper-arrow.next'),
        prevEl: this.querySelector('.custom-swiper-arrow.prev'),
      },
    });
  }
}

if (!customElements.get('product-recommendations-slider')) {
  customElements.define('product-recommendations-slider', ProductRecommendationsSlider);
}
